import React from "react";
import { Box, Divider, Grid, Paper, Typography } from "@mui/material";


// Module scope on purpose: a component declared inside another component is a
// new type on every render, so React remounts its subtree instead of updating it.
const Item = ({ label, value }) => (
  <Box>
    <Typography
      variant="caption"
      sx={{ display: "block", fontWeight: 600, color: "text.secondary" }}
    >
      {label}
    </Typography>
    <Typography variant="body2">{value}</Typography>
  </Box>
);

const ViewWaterProfile = ({ profile }) => {
  if (!profile) {
    return null;
  }

  const formatNumber = (value) => 
    value !== null && value !== undefined ? value.toFixed(2) : "N/A";

  const chemicalProperties = [
    { label: "Calcium", value: formatNumber(profile.calcium), unit: "mg/L" },
    { label: "Total Alkalinity", value: formatNumber(profile.totalAlkalinity), unit: "mg/L" },
    { label: "Bicarbonate", value: formatNumber(profile.bicarbonate), unit: "mg/L" },
    { label: "Sulfate", value: formatNumber(profile.sulfate), unit: "mg/L" },
    { label: "Magnesium", value: formatNumber(profile.magnesium), unit: "mg/L" },
    { label: "Total Hardness", value: formatNumber(profile.totalHardness), unit: "mg/L" },
    { label: "Iron", value: formatNumber(profile.iron), unit: "mg/L" },
    { label: "pH", value: formatNumber(profile.pH), unit: "" },
    { label: "Total Chlorine", value: formatNumber(profile.totalChlorine), unit: "mg/L" },
    { label: "Residual Alkalinity", value: formatNumber(profile.residualAlkalinity), unit: "mg/L" },
    { label: "Chloride", value: formatNumber(profile.chloride), unit: "mg/L" },
    { label: "Sulfate to Chloride Ratio", value: formatNumber(profile.sulfateToChlorideRatio), unit: "" },
    { label: "Sodium", value: formatNumber(profile.sodium), unit: "mg/L" },
    { label: "Zinc", value: formatNumber(profile.zinc), unit: "mg/L" },
    { label: "Potassium", value: formatNumber(profile.potassium), unit: "mg/L" },
    { label: "Copper", value: formatNumber(profile.copper), unit: "mg/L" },
    { label: "TDS", value: formatNumber(profile.tds), unit: "mg/L" },
  ];


  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Water Profile Details
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Item label="Account Number" value={profile.accountNumber || "N/A"} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Item label="Type" value={profile.type || "N/A"} />
        </Grid>
      </Grid>

      <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2, mb: 1.5 }}>
        Chemical Properties
      </Typography>

      <Grid container spacing={2}>
        {chemicalProperties.map((prop, index) => (
          <Grid size={{ xs: 6, sm: 4, md: 2 }} key={index}>
            <Item
              label={prop.label}
              value={`${prop.value}${prop.unit ? " " + prop.unit : ""}`}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default ViewWaterProfile;
